<template>
    <HeroWithImages v-if="hasHubspotConfig" :slice="props.slice" is-hero-with-form class="slice-hero--with-form">
        <template #hubspot-form>
            <div class="slice-hero--with-form__form-card" data-testid="slice-hero-form">
                <MktHubspotForm
                    :region="slice.primary.hubspotRegion!"
                    :portal-id="slice.primary.hubspotPortalId!"
                    :form-id="slice.primary.hubspotFormId!"
                    :salesforce-id="slice.primary.salesforceId!"
                />
            </div>
        </template>
    </HeroWithImages>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {isFilled} from '@prismicio/helpers';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {HeroSlice, HeroSliceHeroWithForm} from '@prismicio-types';
    import {MktHubspotForm} from '#components';
    import HeroWithImages from './HeroWithImages.vue';

    const props = defineProps(getSliceComponentProps<HeroSlice>());
    const slice = computed(() => props.slice as HeroSliceHeroWithForm);

    const hasHubspotConfig = computed(
        () =>
            isFilled.keyText(slice.value.primary.hubspotRegion) &&
            isFilled.keyText(slice.value.primary.hubspotPortalId) &&
            isFilled.keyText(slice.value.primary.hubspotFormId) &&
            isFilled.keyText(slice.value.primary.salesforceId),
    );
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    $flex-gap: 48px;

    .slice-hero {
        &--with-form {
            .slice-hero__content-wrapper {
                flex-direction: column;
                gap: 44px;

                @include mq.screen_md(min) {
                    flex-direction: row;
                    gap: $flex-gap;
                }
            }

            &__form-card {
                flex: none;
                background: var(--joy-color-neutral-0);
                width: 100%;
                min-width: 40px;
                max-width: 550px;
                margin: 0 auto;
                border-radius: var(--joy-core-radius-4);
                padding: var(--joy-core-spacing-6) var(--joy-core-spacing-5);
                box-shadow: 0 var(--joy-core-spacing-1) var(--joy-core-spacing-5) 0 rgba(51, 51, 48, 0.2);
                height: auto;

                @include mq.screen_md(min) {
                    width: calc(50% - $flex-gap);
                    padding: var(--joy-core-spacing-8) var(--joy-core-spacing-6);
                }
            }
        }
    }
</style>
